import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import inAppLogo from "../assets/inAppLogo.png";
import { getUserInfo } from "../utils/auth";
// import profile from "../assets/profile.png";
import {
  URL_S001,
  URL_S003,
  URL_S005,
  URL_S008,
  ROLE,
} from "../utils/constants";

class Menu extends Component {
  state = {};
  render() {
    const path = this.props.location.pathname.slice(0, 10);
    return (
      <aside
        className="main-sidebar sidebar-dark-primary elevation-4"
        style={{ overFlow: "auto" }}
      >
        {/* Brand Logo */}
        <p className="brand-link mb-0">
          <img
            src={inAppLogo}
            alt="Logo"
            className="brand-image ml-2"
            width="80"
            height="43.25"
          />
          <span className="brand-text font-weight-light">Timesheets</span>
        </p>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            {/* <div className="image align-self-center" width={50}>
              <img
                src={profile}
                className="img-circle elevation-2"
                alt="User"
              />
            </div> */}
            <div className="info">
              <a className="d-block">
                <b>{getUserInfo().name}</b>
              </a>
              <a className="d-block" style={{ fontSize: 13 }}>
                Department: <b>{getUserInfo().department}</b>
              </a>
              <a className="d-block" style={{ fontSize: 13 }}>
                Role: <b>{getUserInfo().userRole}</b>
              </a>
            </div>
          </div>
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to={URL_S001}
                  className="nav-link"
                  style={
                    path === URL_S001
                      ? {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <i className="nav-icon fas fa-copy" />
                  <p>Personal Timesheet List</p>
                </Link>
              </li>
              <li className="nav-item">
                {getUserInfo().userRole === ROLE.entry ? (
                  <Link
                    to={URL_S003 + "/1"}
                    className="nav-link"
                    style={
                      path === URL_S003
                        ? {
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <i className="nav-icon fas fa-copy" />
                    <p>Department Timesheet List</p>
                  </Link>
                ) : getUserInfo().userRole === ROLE.manager ? (
                  <Link
                    to={URL_S005}
                    className="nav-link"
                    style={
                      path === URL_S005
                        ? {
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <i className="nav-icon fas fa-copy" />
                    <p>Summary</p>
                  </Link>
                ) : (
                  getUserInfo().userRole === ROLE.hr && (
                    <>
                      <Link
                        to={URL_S008}
                        className="nav-link"
                        style={
                          path === URL_S008
                            ? {
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                color: "#fff",
                              }
                            : {}
                        }
                      >
                        <i className="nav-icon fas fa-copy" />
                        <p>Summary - HR</p>
                      </Link>
                    </>
                  )
                )}
              </li>
              {getUserInfo().userRole === ROLE.admin && (
                <>
                  <li className="nav-item">
                    <Link
                      to={URL_S003 + "/1"}
                      className="nav-link"
                      style={
                        path === URL_S003
                          ? {
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              color: "#fff",
                            }
                          : {}
                      }
                    >
                      <i className="nav-icon fas fa-copy" />
                      <p>Department Timesheet List</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to={URL_S005}
                      className="nav-link"
                      style={
                        path === URL_S005
                          ? {
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              color: "#fff",
                            }
                          : {}
                      }
                    >
                      <i className="nav-icon fas fa-copy" />
                      <p>Summary</p>
                    </Link>
                  </li>
                </>
              )}
              {(getUserInfo().userRole === ROLE.hr ||
                getUserInfo().userRole === ROLE.admin) && (
                <>
                  <li className="nav-item">
                    <Link
                      to={"/home/report"}
                      className="nav-link"
                      style={
                        path === "/home/report"
                          ? {
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              color: "#fff",
                            }
                          : {}
                      }
                    >
                      <i className="nav-icon fas fa-copy" />
                      <p>Report</p>
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link
                      to={"/home/ws_summary"}
                      className="nav-link"
                      style={
                        path === "/home/ws_summary"
                          ? {
                              backgroundColor: "rgba(255, 255, 255, 0.1)",
                              color: "#fff",
                            }
                          : {}
                      }
                    >
                      <i className="nav-icon fas fa-copy" />
                      <p>Summary Report</p>
                    </Link>
                  </li> */}
                </>
              )}
              <li className="nav-item">
                <Link
                  to="/home/changePassword"
                  className="nav-link"
                  style={
                    path === "/home/changePassword"
                      ? {
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <i className="nav-icon fas fa-lock" />
                  <p>Change Password</p>
                </Link>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    );
  }
}

export default withRouter(Menu);
